import { ProfileMenuItems } from 'shared/components';

const ProfileSidebar = ({ onSideMenuClose, visible }) => {
  return (
    <div
      className={`profile_left_area mobileview ${
        visible ? 'show_usermenu' : ''
      }`}
    >
      <div className="profile_sidebar">
        <div className="filter_top_act">
          <div className="filter_act_inner">
            <button
              type="button"
              className="cls_filter"
              onClick={onSideMenuClose}
            >
              <i className="far fa-times-circle" />
            </button>
          </div>
        </div>

        <ProfileMenuItems />
      </div>
    </div>
  );
};

export default ProfileSidebar;
